module.exports = __webpack_public_path__ + "static/media/P1050664 (2)-min.3af74cd6.JPG";